export const setSelectedSpace = space => ({
  type: 'SET_SELECTED_SPACE',
  payload: space,
});

export const clearSelectedSpace = () => ({
  type: 'CLEAR_SELECTED_SPACE',
});
